import { NIGHTS, START_DATE } from 'contexts/CruiseSearchContext/constants';
import { PROMOTION_STATUS_ACTIVE } from '../../../components/TargetedOffers/Components/Banner/Constants';

export const mapFaceting = ({ promotions, facetOptions, promotionSelected }) => {
	const { criteriaToSearchSelection, valid, status, criteria = [] } = promotions;

	if (status !== PROMOTION_STATUS_ACTIVE) {
		return facetOptions;
	}
	if (!valid || criteria.length === 0 || !promotionSelected) {
		return facetOptions;
	}
	const newfacetOptions = { ...facetOptions };
	Object.keys(newfacetOptions).forEach((val) => {
		const baseCriteria = criteriaToSearchSelection[val];
		const baseFilter = newfacetOptions[val];

		if (val === START_DATE || val === NIGHTS) {
			newfacetOptions[val] = baseFilter;
			return;
		}

		if (criteriaToSearchSelection[val]?.length > 0) {
			const result = Object.keys(baseFilter).reduce((acc, cur) => {
				if (baseCriteria.includes(cur)) {
					acc[cur] = baseFilter[cur];
				}
				return acc;
			}, {});

			newfacetOptions[val] = result;
			return;
		}
	});

	return newfacetOptions;
};
